<template>
  <div class="chart-skeleton-wrapper">
    <div v-if="isLoading" class="chart-skeleton-grid">
      <div class="skeleton-label-column">
        <div class="skeleton-line"></div>
        <div class="skeleton-line"></div>
        <div class="skeleton-line"></div>
        <div class="skeleton-line"></div>
      </div>
      <div class="skeleton-chart-area">
        <div class="skeleton-grid-line top"></div>
        <div class="skeleton-grid-line middle-top"></div>
        <div class="skeleton-grid-line middle-bottom"></div>
        <div class="skeleton-grid-line bottom"></div>
        <div class="skeleton-bars-container">
          <div
            v-for="(height, index) in predefinedBarHeights"
            :key="index"
            class="skeleton-bar"
            :style="{ height: height + '%' }"
          ></div>
        </div>
        <div class="skeleton-x-axis-labels">
          <div
            v-for="i in predefinedBarHeights.length"
            :key="i"
            class="skeleton-x-label"
          ></div>
        </div>
      </div>
    </div>
    <slot v-else></slot>
  </div>
</template>

<script>
export default {
  name: 'ChartSkeleton',
  props: {
    isLoading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      predefinedBarHeights: [15, 8, 8, 35, 65, 85, 95, 60, 75, 45, 30],
    };
  },
};
</script>

<style scoped>
.chart-skeleton-wrapper {
  width: 100%;
  background-color: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
}

.chart-skeleton-grid {
  display: grid;
  grid-template-columns: 50px 1fr;
  min-height: 500px;
  padding: 15px 20px 15px 15px;
  box-sizing: border-box;
}

.skeleton-label-column {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
  padding-right: 10px;
  margin: 15px 0;
}

.skeleton-line {
  width: 34px;
  height: 20px;
  background: linear-gradient(90deg, #F1EFEF -24.18%, #F9F8F8 50.26%, #E7E5E5 114.84%);
  background-size: 200% 100%;
  border-radius: 4px;
  animation: shimmer 1.4s infinite;
}

.skeleton-chart-area {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.skeleton-grid-line {
  position: absolute;
  left: 0;
  width: 100%;
  border-bottom: 1px dashed #E5E5E7;
  z-index: 1;
}

.skeleton-grid-line.top {
  top: 5%;
}
.skeleton-grid-line.middle-top {
  top: 35%;
}
.skeleton-grid-line.middle-bottom {
  top: 65%;
}
.skeleton-grid-line.bottom {
  top: 95%;
}

.skeleton-bars-container {
  display: flex;
  align-items: flex-end;
  justify-content: space-around;
  height: calc(100% - 30px);
  box-sizing: border-box;
  z-index: 2;
}

.skeleton-bar {
  width: 40px;
  background: linear-gradient(90deg, #F1EFEF -24.18%, #F9F8F8 50.26%, #E7E5E5 114.84%);
  background-size: 200% 100%;
  border-radius: 5px 5px 0 0;
  animation: shimmer 1.4s infinite;
  margin: 0 5px;
  min-height: 5px;
}

.skeleton-x-axis-labels {
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 25px;
  width: 100%;
  padding-top: 10px;
}

.skeleton-x-label {
  width: 60px;
  height: 20px;
  background: linear-gradient(90deg, #F1EFEF -24.18%, #F9F8F8 50.26%, #E7E5E5 114.84%);
  background-size: 200% 100%;
  border-radius: 4px;
  animation: shimmer 1.4s infinite;
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>
